import script from "./DomainPickerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainPickerModal.vue?vue&type=script&setup=true&lang=js"

import "./DomainPickerModal.vue?vue&type=style&index=0&id=782e87c9&lang=scss"

const __exports__ = script;

export default __exports__